import { Box } from "@mui/material";
import type { ReactNode } from "react";

interface PageContainerProps {
  children: ReactNode;
}

export function PageContainer({ children }: PageContainerProps) {
  return (
    <Box
      sx={{ p: { xs: 2, md: 4 }, maxWidth: 1280, mx: "auto", width: "100%" }}
    >
      {children}
    </Box>
  );
}
